import { IEltCompanyPerformanceItem } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCompanyPerfomance'
import { IBalanceOfTrade } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { PERFORMANCE_REVENUE_TOTAL } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import {
  createBoTItem,
  getFieldsByActualsValueTypes,
} from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/balanceOfTradeFieldsHelper'
import { getDataOrNil } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getDataOrNil'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getFormedEltTranslationForKeys } from '../getFormedEltTranslationForKeys'

export const getBoTByCompanyPerformanceRevenueInitialData = (
  companyPerformance: IEltCompanyPerformanceItem[],
  previousBoTData?: IBalanceOfTrade[],
  actualValueTypes: ActualsValueTypes[] = []
): IBalanceOfTrade[] => {
  const totalItem = companyPerformance.find((el) => el.TranslationKey === PERFORMANCE_REVENUE_TOTAL)

  const previousHPSpend = previousBoTData?.find((el) => el.Key === 'HPSpend')

  const hpSpendFields = getFieldsByActualsValueTypes(
    actualValueTypes,
    ({ postfix, hpSpendField }) => {
      if (!hpSpendField) {
        return 0
      }

      return getDataOrNil(
        previousHPSpend?.[`${hpSpendField}${postfix}` as keyof IBalanceOfTrade] as
          | number
          | undefined
      )
    }
  )

  const totalRevenueFields = getFieldsByActualsValueTypes(
    actualValueTypes,
    ({ postfix, totalRevenueField }) => {
      if (!totalRevenueField) {
        return 0
      }

      return getDataOrNil(
        totalItem?.[`${totalRevenueField}${postfix}` as keyof IEltCompanyPerformanceItem] as
          | number
          | undefined
      )
    }
  )

  const balanceOfTradeFields = getFieldsByActualsValueTypes(
    actualValueTypes,
    ({ postfix, totalRevenueField, hpSpendField }) => {
      if (!totalRevenueField || !hpSpendField) {
        return 0
      }

      const totalRevenue = getDataOrNil(
        totalItem?.[`${totalRevenueField}${postfix}` as keyof IEltCompanyPerformanceItem] as
          | number
          | undefined
      )

      const hpSpend = getDataOrNil(
        previousHPSpend?.[`${hpSpendField}${postfix}` as keyof IBalanceOfTrade] as
          | number
          | undefined
      )

      return totalRevenue - hpSpend
    }
  )

  return [
    createBoTItem('HPSpend', getFormedEltTranslationForKeys('doc-hp-spend'), hpSpendFields),
    createBoTItem(
      'TotalRevenue',
      getFormedEltTranslationForKeys('doc-total-revenue'),
      totalRevenueFields
    ),
    createBoTItem(
      'BalanceOfTrade',
      getFormedEltTranslationForKeys('doc-balance-of-trade'),
      balanceOfTradeFields
    ),
  ]
}
